module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageMobile-EN.665f4638.webp";